<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
        v-for="breadcrumb in breadcrumbs"
        :key="breadcrumb.name"
        :disabled="typeof breadcrumb.link === 'undefined'"
        :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{title}}</h1>
      </v-flex>
    </v-layout>

    <div v-if="productStockSettingList !== null ? productStockSettingList.length > 0 : false">
      <v-layout row class="mx-3">
        <v-flex xs12>
          <template>
            <v-data-table
              :headers="headers"
              :items="productStockSettingList"
              hide-actions
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                  <span class="cursor-pointer" @click="$router.push('/product/stock/setting/single/' + props.item.id)">{{props.item.title}}</span>
                </td>
                <td class="text-xs-left">
                  <div>
                    <v-btn
                      flat
                      icon
                      class="ma-1"
                      @click="editProductStockSetting(props.item.id)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      icon
                      class="ma-1"
                      @click="deleteProductStockSetting(props.item.id)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </div>
                </td>
              </template>
            </v-data-table>
          </template>
        </v-flex>
      </v-layout>
    </div>

    <div v-if="productStockSettingList !== null ? productStockSettingList.length === 0 : false">
      <div class="ml-3 subheading">Нет скрытых остатков. <span @click="$router.push('/product/stock/setting/new')" class="cursor-pointer primary--text">Добавить</span></div>
    </div>

    <v-layout row v-if="pages > 1">
      <v-flex xs12>
        <div class="text-xs-left mt-3">
          <v-pagination
            v-model="page"
            :length="pages"
            :total-visible="7"
            @input="changePage()"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="deleteDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title class="headline">Удалить скрытый остаток?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error"
            @click="deleteProductStockSettingConfirm(deleteProductStockSettingId)"
          >
            Удалить
          </v-btn>

          <v-btn
            @click="deleteProductStockSettingCancel()"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import HelpMixin from '../../mixins/help'

  export default {
    mixins: [HelpMixin],
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Ограничения'}
        ],
        headers: [
          {
            text: 'Название',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Действия',
            align: 'left',
            sortable: false,
            value: 'name'
          }
        ],
        pageDataReady: {
          isReady: false,
          productStockSettingList: false
        },
        page: 1,
        title: 'Список скрытых остатков',
        deleteDialog: false,
        deleteProductStockSettingId: null
      }
    },
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.productStockSettingList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      changePage () {
        this.scrollUp()

        this.pageDataReady = {
          isReady: false,
          productStockSettingList: false
        }
        this.$store.commit('setPageLoading', true)

        this.$router.push('/product/stock/setting/active/' + this.page)
      },
      editProductStockSetting (id) {
        this.$router.push('/product/stock/setting/edit/' + id)
      },
      deleteProductStockSetting (id) {
        this.deleteDialog = true
        this.deleteProductStockSettingId = id
      },
      deleteProductStockSettingCancel () {
        this.deleteDialog = false
        this.deleteProductStockSettingId = null
      },
      deleteProductStockSettingConfirm () {
        this.deleteDialog = false
        this.$store.dispatch('deleteProductStockSetting', {id: this.deleteProductStockSettingId})
        this.deleteProductStockSettingId = null
        this.$store.dispatch('getProductStockSettingList', {offset: (this.page - 1) * 10, limit: 10})
      },
      onCreated () {
        if (typeof this.$route.params.page !== 'undefined') {
          this.page = parseInt(this.$route.params.page)
        } else {
          this.page = 1
        }
        if (~this.$router.currentRoute.path.indexOf('/product/stock/setting/active')) {
          this.title = 'Список скрытых остатков'
        }
        this.$store.commit('setPageLoading', true)
        this.$store.commit('setPageTitle', this.title)

        this.$store.dispatch('getProductStockSettingList', {offset: (this.page - 1) * 10, limit: 10})
          .then(() => {
            this.pageDataReady.productStockSettingList = true
            this.pageDataStatus()
          })
      }
    },
    computed: {
      productStockSettingList () {
        return this.$store.getters.productStockSettingList
      },
      totalCount () {
        return this.$store.getters.productStockSettingTotalCount
      },
      pages () {
        let pages = this.totalCount / 10
        if ((pages ^ 0) !== pages) {
          pages = Math.floor(pages) + 1
        }
        return pages
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ProductStockSetting/ProductStockSettingList.vue